var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#3EFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65625 5.89894L9 2.8125L14.3438 5.89894V12.1011L9 15.1875L3.65625 12.1011V5.89894ZM4.16925 11.5071L6.31238 10.2668L7.39969 8.36269L4.16925 6.4935V11.5071ZM4.42631 11.952L8.75869 14.4546V12.06L6.48731 10.7589L4.42631 11.952ZM13.8307 6.51094L10.629 8.36325L11.7157 10.2656L13.8307 11.4896V6.51094ZM13.5889 6.05644L9.27169 3.56288V5.98669L10.3742 7.91663L13.5889 6.05644ZM10.1874 8.61862L9.52819 9L10.836 9.75656L10.1874 8.61862ZM9.93263 8.172L9.27169 7.01325V8.5545L9.93263 8.172ZM7.19662 9.75544L8.50163 9L7.84406 8.61975L7.19719 9.75544H7.19662ZM7.002 10.4619L8.75869 11.4677V9.4455L7.002 10.4619ZM4.42575 6.048L7.6545 7.9155L8.75869 5.98331V3.54544L4.42575 6.048ZM13.5889 11.9436L11.5436 10.7601L9.27169 12.0769V14.4371L13.5889 11.9436ZM11.0306 10.4631L9.27169 9.4455V11.4829L11.0306 10.4631ZM8.09888 8.17312L8.75869 8.5545V7.01606L8.09888 8.17312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbt);
export default __webpack_public_path__ + "static/media/abt.7a55bb96ae10dc4582ca7a64c21818ae.svg";
export { ForwardRef as ReactComponent };